import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService, AnalyticsService, IntercomService } from '@campfire-nx/api';
import { AuthService } from '@open-portal-app/core/services/auth.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
  isLoading = false;
  isLoggedIn!: any;
  userInitials?: string = undefined;

  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
    private intercomService: IntercomService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.isLoggedIn = this.authService.isAuthenticated();

    if (this.isLoggedIn) {
      this.userService.details()
        .then((data) => {
          const firstInitial = data.first_name ? data.first_name[0] : undefined;
          const lastInitial = data.last_name ? data.last_name[0] : undefined;

          if (firstInitial || lastInitial) {
            this.userInitials = firstInitial + lastInitial;
          }
        })
        .then(() => this.isLoading = false);
    }
  }

  logout() {
    this.intercomService.shutdown();
    this.analyticsService.trackEvent(
      'click-logout',
      'general',
      'logout',
      {}
    );
    this.router.navigate(['/logout']);
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }
}
